import { ISchedulingForm } from '../models';

export function validateSchedulingForm(data: Partial<ISchedulingForm>) {
	return !!(
		data.sendRespondentCount &&
		data.offices?.length &&
		data.startDate?.isValid() &&
		data.sendingTime
	);
}
